import { Component, computed, inject, model } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { VisitorAdminService } from '@api-client';
import { ChartComponent, ChartOptions, DateRange } from '@client-libs';
import { StatisticsStore } from '../../../../stores/statistics.store';

@Component({
  selector: 'app-device-type',
  templateUrl: './device-type.component.html',
  imports: [ChartComponent, DateRange],
})
export class DeviceTypeComponent {
  readonly visitorService = inject(VisitorAdminService);
  readonly statisticsStore = inject(StatisticsStore);

  $data = rxResource({
    stream: ({ params }) =>
      this.visitorService.visitorAdminControllerGetDeviceTypeV1({
        endAt: this.endAt()?.toString()!,
        startAt: this.startAt()?.toString()!,
        type: 'month',
      }),
  });
  data = computed(() => this.$data.value());

  devices = computed(() => this.data()?.devices);
  oses = computed(() => this.data()?.oses);
  browsers = computed(() => this.data()?.browsers);

  startAt = model<Date>();
  endAt = model<Date>();

  options = computed<ChartOptions>(() => ({
    tooltip: {
      custom: (data: any) => this.customTooltip(data),
    },
    plotOptions: {
      bar: {
        columnWidth: '20%',
      },
    },
    chart: {
      type: 'pie',
      fontFamily: 'inherit',
      height: 240,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    colors: ['#2b7fff', '#FF9800', '#34C759'],
    series: this.oses()?.counts ?? [],
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    labels: this.oses()?.labels,
  }));

  getPercent(value: number, array: number[]) {
    const total = array.reduce((acc, cur) => acc + cur, 0);
    const result = Math.round((value / total!) * 100);
    return `${result}%`;
  }

  customTooltip(data: any) {
    const { series, seriesIndex } = data;

    return `<div class="min-w-[3rem] tooltip-shadow p-2.5 flex flex-col justify-center items-center gap-1 bg-base-100">
              <div class="text-base-content">총 방문자 수 : ${series[seriesIndex]}명</div>
              <div class="text-base-content/60">${this.options().labels[seriesIndex]}</div>
            </div>`;
  }

  handleDateChange() {
    if (this.startAt() && this.endAt()) {
      this.$data.reload();
      this.statisticsStore.setDateOption(this.startAt()!, this.endAt()!);
    }
  }

  handleReset() {
    this.startAt.set(undefined);
    this.endAt.set(undefined);
    this.statisticsStore.reset();
    this.$data.reload();
  }
}
